import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { KeycloakEmailValidationError } from "../enums/KeycloakEmailValidationError";
import {
  EMPTY_CHARACTER,
  REGEX_FOR_EMAIL_VALIDATION,
} from "@pulse/shared-components";
import { KeycloakEmail } from "@pulse/pulse-rpcs/lib/types/keycloakEmail";

const validateAndGetKeycloakEmailValidationError = (
  value: string,
): KeycloakEmailValidationError | undefined => {
  const trimmedValue = value.trim();
  if (!trimmedValue.length) return KeycloakEmailValidationError.EmptyValue;

  const keycloakEmailRegex = new RegExp(REGEX_FOR_EMAIL_VALIDATION);
  if (!keycloakEmailRegex.test(trimmedValue)) {
    return KeycloakEmailValidationError.InvalidEmailId;
  }
};

export const KeycloakEmailModel = types
  .model("KeycloakEmailModel", {
    value: types.string,
    validationError: types.maybe(
      types.enumeration(
        "KeycloakEmailValidationError",
        Object.values(KeycloakEmailValidationError),
      ),
    ),
  })
  .views((store) => ({
    get rpcObject(): KeycloakEmail {
      return new KeycloakEmail(store.value);
    },
  }))
  .actions((store) => ({
    setValue: (value: SnapshotIn<typeof KeycloakEmailModel>["value"]): void => {
      store.validationError = validateAndGetKeycloakEmailValidationError(value);
      store.value = value;
    },
  }));

export const createKeycloakEmailModel = (
  keycloakMail?: SnapshotIn<typeof KeycloakEmailModel>,
): Instance<typeof KeycloakEmailModel> =>
  KeycloakEmailModel.create(keycloakMail ?? { value: EMPTY_CHARACTER });
